import React from 'react';
import { Trophy, Target, X, Users, Crosshair } from 'lucide-react';
import './BRMultistep.css';

const MultistepTypeSelector = ({ onSelect, onClose, t }) => {
  return (
    <div className="multistep-selector-overlay">
      <div className="multistep-selector-modal">
        <div className="multistep-selector-header">
          <div className="multistep-selector-title">
            <Trophy className="w-6 h-6 text-yellow-400" />
            <h2>{t('selectTournamentType', 'Select Tournament Type')}</h2>
          </div>
          <button className="multistep-selector-close" onClick={onClose}>
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="multistep-selector-options">
          <button
            className="multistep-option mp-option"
            onClick={() => onSelect('mp_multistep')}
          >
            <div className="option-icon mp">
              <Users className="w-8 h-8" />
            </div>
            <div className="option-content">
              <h3>{t('mpMultistep', 'MP Multistep')}</h3>
              <p>{t('mpMultistepDesc', 'Team-based multiplayer tournament with bracket progression. 5 players per team.')}</p>
              <ul className="option-features">
                <li>{t("teamsCount", "4, 8, or 16 teams")}</li>
                <li>{t("bracketElimination", "Bracket elimination format")}</li>
                <li>{t("gameModePerMatch", "Game mode set per match")}</li>
              </ul>
            </div>
          </button>

          <button
            className="multistep-option br-option"
            onClick={() => onSelect('br_multistep')}
          >
            <div className="option-icon br">
              <Target className="w-8 h-8" />
            </div>
            <div className="option-content">
              <h3>{t('brMultistep', 'BR Multistep')}</h3>
              <p>{t('brMultistepDesc', 'Battle Royale tournament with multiple rounds. Points-based scoring system.')}</p>
              <ul className="option-features">
                <li>{t("soloSquadModes", "Solo, Duo, or Squad modes")}</li>
                <li>{t("roundsRange", "2-5 rounds")}</li>
                <li>{t("cumulativePoints", "Cumulative points from kills + placement")}</li>
              </ul>
            </div>
          </button>

          <button
            className="multistep-option ffa-option"
            onClick={() => onSelect('ffa_multistep')}
          >
            <div className="option-icon ffa">
              <Crosshair className="w-8 h-8" />
            </div>
            <div className="option-content">
              <h3>{t('ffaMultistep', 'FFA Tournament')}</h3>
              <p>{t('ffaMultistepDesc', 'Free For All tournament with lobbies of up to 8 players. Admin approves players and picks winners.')}</p>
              <ul className="option-features">
                <li>{t("maxPlayers64", "Up to 64 players")}</li>
                <li>{t("twoRounds", "2 rounds: Lobbies + Finals")}</li>
                <li>{t("adminApproval", "Admin approval required")}</li>
              </ul>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MultistepTypeSelector;
